import ScreenIcon from '@atlaskit/icon/core/screen';
import OldScreenIcon from '@atlaskit/icon/glyph/screen';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';

import { useAnalytics } from '@townsquare/analytics';
import { settingsRoute } from '@townsquare/settings-view/route';

import { RouterLinkItem } from '../RouterLinkItem';

import AdminLinksQuery, { AdminLinksQuery as AdminLinksQueryType } from './__generated__/AdminLinksQuery.graphql';

export function WorkspaceSettingsLink(props: { queryRef: PreloadedQuery<AdminLinksQueryType> }) {
  const analytics = useAnalytics();
  const handleWorkspaceSettingsClick = () => {
    void analytics.ui('workspaceSettings', 'clicked');
  };

  const data = usePreloadedQuery(AdminLinksQuery, props.queryRef);

  if (!data.workspace?.userWorkspacePermissions?.admin) {
    return null;
  }

  return (
    <RouterLinkItem
      onClick={handleWorkspaceSettingsClick}
      to={settingsRoute}
      attributes={{ params: { pageName: 'workspace' } }}
      testId="nav-workspace-settings-link"
      iconBefore={<ScreenIcon label="" LEGACY_fallbackIcon={OldScreenIcon} />}
      description={
        <FormattedMessage
          id="townsquare.navigation.settings.workspace-description"
          defaultMessage="Manage workspace name, domains, user groups, time zone, and goal scoring method"
          description="Description for the workspace settings link in the settings dropdown"
        />
      }
    >
      <FormattedMessage
        id="townsquare.navigation.settings.workspace-settings"
        defaultMessage="Workspace settings"
        description="Label for the workspace settings link in the settings dropdown"
      />
    </RouterLinkItem>
  );
}
